import React, { useEffect, useState } from 'react';
import { Button } from './Button';
import { CalendarIcon } from 'lucide-react';
export const ProgressBar = () => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight - windowHeight;
      const scrolled = window.scrollY;
      const progress = scrolled / documentHeight * 100;
      setProgress(progress);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed bottom-0 left-0 right-0 bg-[#231232]/95 backdrop-blur-md border-t border-[#6805DA]/20 py-4 z-50 shadow-xl" data-id="element-358">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-359">
        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8" data-id="element-360">
          <div className="w-full sm:flex-1" data-id="element-361">
            <div className="h-2 bg-[#6805DA]/20 rounded-full" data-id="element-362">
              <div className="h-full bg-gradient-to-r from-[#6805DA] to-[#4B0599] rounded-full transition-all duration-300" style={{
              width: `${progress}%`
            }} data-id="element-363" />
            </div>
          </div>
          <Button variant="gradient-primary" size="md" className="w-full sm:w-auto whitespace-nowrap font-medium" href="/start" data-id="element-364">
            <CalendarIcon className="mr-2" size={16} data-id="element-365" /> Schedule a Consultation
          </Button>
        </div>
      </div>
    </div>;
};